import { render, staticRenderFns } from "./EndorsementStatusBadge.vue?vue&type=template&id=fbf16d0c&scoped=true"
import script from "./EndorsementStatusBadge.vue?vue&type=script&lang=ts"
export * from "./EndorsementStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf16d0c",
  null
  
)

export default component.exports